module.exports = __webpack_public_path__ + "img/mobile.b0e4dec.svg";